import React from 'react';

const FlimoraIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="70"
            height="70"
            version="1.1"
            viewBox="0 0 133.333 133.333"
            xmlSpace="preserve"
        >
            <defs>
                <clipPath id="clipPath20" clipPathUnits="userSpaceOnUse">
                    <path d="M960 0H40C17.91 0 0 17.91 0 40v920c0 22.09 17.91 40 40 40h920c22.09 0 40-17.91 40-40V40c0-22.09-17.91-40-40-40"></path>
                </clipPath>
                <clipPath id="clipPath30" clipPathUnits="userSpaceOnUse">
                    <path d="M960 0H40C17.91 0 0 17.91 0 40v920c0 22.09 17.91 40 40 40h920c22.09 0 40-17.91 40-40V40c0-22.09-17.91-40-40-40"></path>
                </clipPath>
                <clipPath id="clipPath36" clipPathUnits="userSpaceOnUse">
                    <path d="M960 0H40C17.91 0 0 17.91 0 40v920c0 22.09 17.91 40 40 40h920c22.09 0 40-17.91 40-40V40c0-22.09-17.91-40-40-40"></path>
                </clipPath>
                <clipPath id="clipPath48" clipPathUnits="userSpaceOnUse">
                    <path d="M960 0H40C17.91 0 0 17.91 0 40v920c0 22.09 17.91 40 40 40h920c22.09 0 40-17.91 40-40V40c0-22.09-17.91-40-40-40"></path>
                </clipPath>
            </defs>
            <g transform="matrix(1.33333 0 0 -1.33333 0 133.333)">
                <g transform="scale(.1)">
                    <g>
                        <g clipPath="url(#clipPath20)">
                            <path
                                fill="#2a3944"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M1012.83-52.828H-12.836c-22.09 0-40 17.91-40 40V1012.84c0 22.09 17.91 40 40 40H1012.83c22.09 0 40-17.91 40-40V-12.828c0-22.09-17.91-40-40-40"
                            ></path>
                        </g>
                    </g>
                    <g>
                        <g clipPath="url(#clipPath30)">
                            <g clipPath="url(#clipPath36)">
                                <g transform="translate(-10.1 -10.1) scale(1020.2)">
                                    <image
                                        width="1"
                                        height="1"
                                        imageRendering="optimizeSpeed"
                                        preserveAspectRatio="none"
                                        transform="matrix(1 0 0 -1 0 1)"
                                        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABmCAYAAAA53+RiAAAABHNCSVQICAgIfAhkiAAAA/5JREFUeJztnVuSozoQRDMrWMr9ns/Z/8qo+6EHAssYMEY1EXk6oo2xw4I6lCRMU83//vx1BwHMgDscmbpQmLcrxCXsdRUBAgAJpiVMRYq7NzLmjhhxD5sDnADc4AAIhxMgiGktZRHiXszI0P2wWcq9FQF3q3KmKsWTySSk2Gk/TILugaixJOAOkEyrOFc5U1eKA8DeeCOu48uY4gTocHeQluWkh6m+fStF2fI7nCmidNABkFlO7tZgmEq2FCneyFk+6EM7EldhM368f1MZKliSpvyqsZ4ANIP/Roor6Gc5Ei967cvQmGmypk6qvfldW5CUH7H0SuU5XnolW02Lm6yRlN/i2PZSeTlj2L4mBtEamJdZWX3xTLa4dL6FByYBO0z9k8kdJOMYbZwuSFoN/qcaE8e5ELeXrzrfdmOS8iimgT8mTcbsGFK2fM/JGNbpsohF53KaeIq90xJTusREGROUlRh9PxYH+3iVUjOyIZw78xePYXISEw3+QZGYoFQxmpHFQhkTFNOXlzFRxgRFYoIiMUExQDOyiChjgvL+KxnNyIaijAmKxARFYoIiMUExTZVj0s8YzciGo64sKBITlL6YL2+6Ed+jjAmKxATF3hYMUHc2lP2MkZxhGHiwzIZ4lM9jjLJmCFZqNO1mjeQ8Ts4YyYmGreItOWEwgDneOeiSEwLLdWXXciA5ozHS8CKnJo/kjMIAQHLiYWA5lanlsjePkjOCNMbQci3GZtosOUMxMgdfckJhQBYiOaFIGSM54TCSkJx45DN/yYmGleBLTiwMVYjkRCJd85eccFgeZSQnGAYSkhOP2pVJTiyyDsmJxnKhTHJCYW1AJScO6UKZ5ITDSmAkJxbp8qXkhGP5E1nJCYWt4iQ5YchdWbNGckLQdGXNWskZzvqOMskJw3IeU5CcENSuTHJisbqjTHLi8HKrn+Q8x96+du/BlJzxvL05VnLGsnvXsuTcyMnt/Xg7ueSM4VAtGcl5nsNFfiTnCy5s36nqS5JzEvLEdrXvs/NlsSRnhyLilJA+l+qVhZfzS0Hb4F8U0duvNpiXC8mFltNsx7Wduyf4h5vrrPuqwt8/IeddQB8Ofm22xiI9ax/ZtP116cWn5bDdIeKznHZ7Hgp+t/lWSNkHtCHj8sCbamI+KQetHOCcnAdg74dbISVD0CyXfUh/hjHduUG1HD2x/KdAEnBPr9MBT2F0AjAHZ8LzdrsvB7O7gZzzZxqIORVQL59Bh3tuiACdj/3nqO6BsHtsrA/cVa6sDrJcoYS8T0z6+N/LAQjHvJEDgA7m5TsEfRX8zupul1WyqfO+W8Xkpn4qBz6DtI2c3BhTY0cF/S74nfdy/aQd6EvZGOZsIYj/AQpXOvNpdU2LAAAAAElFTkSuQmCC"
                                    ></image>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g>
                        <g
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            clipPath="url(#clipPath48)"
                        >
                            <path
                                fill="#2a3944"
                                d="M500-113.699L-113.695 500l83.457 533.18 1066.608 7.09V-36.262L500-113.699"
                            ></path>
                            <path
                                fill="#64c9a9"
                                d="M773.223 501.105L430.668 158.547 259.414 329.805l342.551 342.55 171.258-171.25"
                            ></path>
                            <path
                                fill="#fff"
                                d="M257.754 687.41l128.164-128.16c18.305-18.305 18.305-47.988 0-66.289L580.371 687.41 419.063 848.723 257.754 687.41"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default FlimoraIcon;